import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

import ModalCreate from '../components/Garantias/ModalCreate'
import ModalDelete from '../components/Garantias/ModalDelete'
import ModalFilter from '../components/Garantias/ModalFilter'

import {
    getGarantias,
	toggleSelectItem,
	toggleSelectAllItems,
	filterGarantias,
	setOrderBy,
	displayModalCreate,
	showHideModalDelete,
	deleteGarantias,
    changeRecordsToShow,
    showHideModalFilter,
} from '../actions/garantias'

export const tableCols = [
    { Id: 1, Caption: 'Nombre', Value: 'nombre', Type: 'string', Format: '', Width: '15%', LinkToEdit: true },
    { Id: 2, Caption: 'Garantia', Value: 'texto', Type: 'html', Format: '', Width: '85%' },
]

export function findValues(c, x) {
	let value = x.getIn(c.Value.split('.'))
	return value
}

class Garantias extends Component {
    componentWillMount() {
        this.props.getGarantias(1)
    }

	render() {
        const { garantias, orderBy, page, totalRecords, showRecords } = this.props

        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de garantias', 'create') } title="Nueva garantia"/>,
            <BoxButton key="ba[1]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Garantias seleccionadas?`, () => this.props.deleteGarantias()) } disabled={ garantias.filter(x => x.get('selected')).count() === 0 } danger title="Eliminar parámetro" />,
            <BoxButton key="ba[2]" name="filter" onClick={ e => this.props.showHideModalFilter(true) } title="Filtro"/>,
        ]

        const pagination = <Pagination
                            activePage={ page }
                            itemsCountPerPage={ showRecords }
                            totalItemsCount={ totalRecords }
                            pageRangeDisplayed={ 10 }
                            onChange={ (pg) => this.props.getGarantias(pg)  }
                            firstPageText={ <FontAwesome name="angle-double-left" /> }
                            prevPageText={ <FontAwesome name="angle-left" /> }
                            nextPageText={ <FontAwesome name="angle-right" /> }
                            lastPageText={ <FontAwesome name="angle-double-right" /> }
                        />

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Garantias disponibles" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                            totalRecords={ totalRecords }
                            showRecords={ showRecords }
                            changeRecordsToShow={ (records) => this.props.changeRecordsToShow(records) }
                            pagination={ pagination }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-garantias">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(e.target.checked) } checked={ garantias.filter(x => x.get('selected')).count() > 0 && garantias.filter(x => x.get('selected') && x.get('visible')).count() >= garantias.filter(x => x.get('visible')).count() } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.Width}` }
                                                return (
                                                    <th key={ `th1[${x.Id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.Value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.Caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        garantias.filter(x => x.get('visible')).count() > 0 ? garantias.filter(x => x.get('visible')).map(x => {
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectItem(x.get('id'), e.target.checked) } checked={ x.get('selected') } />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.Type) {
                                                                switch (c.Type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'html':
                                                                        value = <div style={{ maxHeight: '10vh', overflowX: 'hidden' }} dangerouslySetInnerHTML={{ __html: value }} />
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.Id}]` } className='LinkToEdit' style={ style } onClick={ e => this.props.displayModalCreate(true, 'Modificación de garantias', 'edit', x.get('id')) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.Id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
				<ModalCreate />
                <ModalDelete />
                <ModalFilter />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        garantias: state.garantias.get('garantias'),
        orderBy: state.garantias.get('orderBy'),
        totalRecords: state.garantias.get('totalRecords'),
        showRecords: state.garantias.get('showRecords'),
        page: state.garantias.get('page'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGarantias: (page) => dispatch(getGarantias(page)),
		toggleSelectItem: (id, checked) => dispatch(toggleSelectItem(id, checked)),
		toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
		filterGarantias: (term) => dispatch(filterGarantias(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		displayModalCreate: (show, title, mode, id) => dispatch(displayModalCreate(show, title, mode, id)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deleteGarantias: () => dispatch(deleteGarantias()),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state) => dispatch(showHideModalFilter(state)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Garantias)


// WEBPACK FOOTER //
// ./src/containers/Garantias.jsx